export const defaultBankAllSelector = (state) =>
  state?.defaultBankReducer?.defaultBankAll;
export const defaultBankOpenAddSelector = (state) =>
  state?.defaultBankReducer?.defaultBankOpenAdd;
export const defaultBankOpenEditSelector = (state) =>
  state?.defaultBankReducer?.defaultBankOpenEdit;
export const defaultBankSelectedSelector = (state) =>
  state?.defaultBankReducer?.defaultBankSelected;
export const defaultBankSearchSelector = (state) =>
  state?.defaultBankReducer?.defaultBankSearch;
export const defaultBankLastSelector = (state) =>
  state?.defaultBankReducer?.defaultBankLast;
